// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b948f99b","455":"39f70c81"}[chunkId] + ".chunk.js";
};